import "react-toastify/dist/ReactToastify.css";

import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { toast, ToastContainer } from "react-toastify";

import { submitArbitratorAssignment } from "../../adapter/assignmentAdapter";
import GoBack from "../../components/GoBack";
import { baseUrlForEnterprise } from "../../variables/variables";
import Assignment from "./Assignment";

const AssignArbitrator = () => {
  const [enterpriseDetail, setEnterPriseDetail] = useState([]);
  const [natureDispute, setNatureDisputre] = useState([]);
  const [enterprise, setEnterPrise] = useState("");
  const [step, setstep] = useState(1);
  const [isDisabled, setDisabled] = useState(true);
  const [Data, setData] = useState({});
  const [loading, setloading] = useState(false);
  const [formattedValue, setFormattedValue] = useState(""); // State for showing formatted value
  useEffect(() => {
    setloading(true);
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    axios
      .get(baseUrlForEnterprise, settings)
      .then((res) => {
        setEnterPriseDetail(res.data.data);
        setloading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong !");
        setloading(false);
        navigate(-1);
        setEnterPriseDetail([]);
      });
  }, []);
  const [dispute1, setdispute1] = useState("");
  const [complexity1, setcomplexity] = useState("");
  const [attributes, setattributes] = useState([]);
  const [formData, setFormData] = useState({
    batchId: "",
    enterpriseName: "",
    natureOfDispute: "",
    noOfCases: "",
    maxClaimValue: "",
    maxCasesToBeAllocatedPerArbitrator: "",
  });
  const navigate = useNavigate();
  const {
    control,
    formState: { errors },
    handleSubmit,
    getValues,
  } = useForm({
    defaultValues: {
      maxClaimValue: "",
      userId: localStorage.getItem("userEmail"),
    },
  });
  const saveData = () => {
    console.log(handleSubmit);
    setloading(true);
    let newObject = getValues();
    console.log(newObject);
    for (let i in { ...newObject, complexity: complexity1 }) {
      if ({ ...newObject, complexity: complexity1 }[i] === "") {
        toast.error("All fields are mandatory");
        setloading(false);
        return;
      }
    }
    const response = submitArbitratorAssignment({
      ...newObject,
      complexity: complexity1,
    });
    response.then((res) => {
      console.log(res.status);
      if (res.status !== "DRAFT") {
        toast.error("Something went wrong !");
        setloading(false);
        return;
      }
      setData(res);
      setstep(2);
      setloading(false);
    });
  };
  function natureDispute1(enterprise) {
    let newarray = [];
    setcomplexity("");
    setdispute1("");
    enterpriseDetail.filter((element) => {
      if (element.name === enterprise) {
        setattributes(element.attributes);
        element.attributes.forEach((myvar) => {
          for (let attdispute in myvar) {
            if (attdispute === "natureOfDispute")
              newarray.push(myvar[attdispute]);
          }
        });
      }
      return newarray;
    });
    setNatureDisputre(newarray);
  }
  const resrthandle = () => {
    setFormData({
      batchId: "",
      enterpriseName: "",
      natureOfDispute: "",
      noOfCases: "",
      maxClaimValue: "",
      maxCasesToBeAllocatedPerArbitrator: "",
    });
    setcomplexity("");
    setdispute1("");
  };
  const formatIndianCurrency = (value) => {
    if (!value) return "";
    const [integerPart, decimalPart] = value.split("."); // Split into integer and decimal parts
    const formattedInteger = new Intl.NumberFormat("en-IN").format(
      integerPart.replace(/,/g, "")
    );
    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };
  switch (step) {
    case 1:
      return (
        <div className="navView">
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <HashLoader color="#FBB04C" />
          </Backdrop>
          <ToastContainer />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2 style={{ color: "#333", fontWeight: "400" }}>
              Assign Arbitator
            </h2>
            <GoBack />
          </div>

          <form onSubmit={handleSubmit()}>
            <div className="formStyle">
              <div className="formItem">
                <Controller
                  name="batchId"
                  control={control}
                  defaultValue={formData.batchId}
                  rules={{
                    required: "Batch ID is required",
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      variant="outlined"
                      label="Batch ID"
                      placeholder="Batch ID"
                      type="text"
                      autoComplete="off"
                      error={!!errors.batchId}
                    />
                  )}
                />
                <span className="validation-message">
                  {errors.batchId?.message}
                </span>
              </div>
              <div className="formItem">
                <Controller
                  name="enterpriseName"
                  control={control}
                  rules={{
                    required: "Enterprise name is required",
                  }}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <InputLabel>Enterprise name</InputLabel>
                      <Select
                        {...field}
                        label="Enterprise name"
                        error={!!errors.enterpriseName}
                        onChange={(event) => {
                          field.onChange(event.target.value);
                          setEnterPrise(event.target.value);
                          natureDispute1(event.target.value);
                          setDisabled(!true);
                        }}
                      >
                        {enterpriseDetail.map((enterprise) => {
                          return (
                            <MenuItem
                              key={enterprise.id}
                              value={enterprise.name}
                            >
                              {enterprise.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <span className="validation-message">
                        {errors.enterpriseName?.message}
                      </span>
                    </FormControl>
                  )}
                />
              </div>
              <div className="formItem">
                <Controller
                  name="natureOfDispute"
                  control={control}
                  defaultValue={formData.natureOfDispute}
                  rules={{
                    required: "Nature of Dispute is required",
                  }}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <InputLabel>Nature of Dispute</InputLabel>
                      <Select
                        {...field}
                        id="disSeelcte"
                        label="Nature of Dispute"
                        error={!!errors.enterpriseName}
                        disabled={isDisabled}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          setdispute1(e.target.value);
                          attributes.forEach((elemnt) => {
                            if (elemnt.natureOfDispute === e.target.value) {
                              setcomplexity(elemnt.complexity);
                            }
                          });
                        }}
                      >
                        {natureDispute.map((dispute, index) => {
                          return (
                            <MenuItem key={index} value={dispute}>
                              {dispute}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <span className="validation-message">
                        {errors.enterpriseName?.message}
                      </span>
                    </FormControl>
                  )}
                />
              </div>
              <div className="formItem">
                <Controller
                  name="complexity"
                  control={control}
                  defaultValue={formData.complexity}
                  rules={{
                    required: "Complexity is required",
                  }}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <InputLabel>Complexity</InputLabel>
                      <Select
                        {...field}
                        value={complexity1}
                        label="complexity"
                        disabled={isDisabled}
                        error={!!errors.enterpriseName}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          setcomplexity(e.target.value);
                        }}
                      >
                        {[
                          "ELEMENTARY",
                          "SIMPLE",
                          "STRAIGHTFORWARD",
                          "ELABORATE",
                          "INTRICATE",
                          "COMPLEX",
                          "COMPLICATED",
                        ].map((dispute, index) => {
                          return (
                            <MenuItem key={index} value={dispute}>
                              {dispute}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <span className="validation-message">
                        {errors.enterpriseName?.message}
                      </span>
                    </FormControl>
                  )}
                />
              </div>
              <div className="formItem">
                <Controller
                  name="noOfCases"
                  control={control}
                  defaultValue={formData.noOfCases}
                  rules={{
                    required: "Number of Cases is required",
                    pattern: {
                      value: /^[0-9]*$/,
                      message: "Please enter a valid number",
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      autoComplete="off"
                      id="phone"
                      label="No of Cases"
                      disabled={isDisabled}
                      variant="outlined"
                      error={!!errors.noOfCases}
                    />
                  )}
                />
                <span className="validation-message">
                  {errors.noOfCases?.message}
                </span>
              </div>
              <div className="formItem">
                <Controller
                  name="maxCasesToBeAllocatedPerArbitrator"
                  control={control}
                  defaultValue={formData.maxCasesToBeAllocatedPerArbitrator}
                  rules={{
                    required: "Maximum Cases per Arbitrator is required",
                    pattern: {
                      value: /^[0-9]*$/,
                      message: "Please enter a valid number",
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      autoComplete="off"
                      label="Maximum Cases per Arbitrator"
                      variant="outlined"
                      disabled={isDisabled}
                      error={!!errors.maxCasesToBeAllocatedPerArbitrator}
                    />
                  )}
                />{" "}
                <span className="validation-message">
                  {errors.maxCasesToBeAllocatedPerArbitrator?.message}
                </span>
              </div>
              <div className="formItem">
                <Controller
                  name="maxClaimValue"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Average Claim Value is required",
                    pattern: {
                      value: /^[0-9,.]*$/,
                      message: "Please enter a valid number",
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      autoComplete="off"
                      label="Average Claim Value"
                      variant="outlined"
                      disabled={isDisabled}
                      error={!!errors.maxClaimValue}
                      value={formattedValue} // Show formatted value
                      onChange={(e) => {
                        let inputValue = e.target.value;

                        // Allow only numbers, commas, and a single decimal point
                        if (/^[0-9,.]*$/.test(inputValue)) {
                          // Remove invalid characters and format
                          inputValue = inputValue.replace(/[^0-9.]/g, ""); // Keep only numbers and dot
                          const parts = inputValue.split(".");
                          if (parts.length > 2) return; // Prevent multiple decimals

                          const rawValue = inputValue.replace(/,/g, ""); // Remove commas
                          const formatted = formatIndianCurrency(rawValue);

                          setFormattedValue(formatted); // Display formatted value
                          field.onChange(rawValue); // Store raw value for form submission
                        }
                      }}
                    />
                  )}
                />
                <span className="validation-message">
                  {errors.maxClaimValue?.message}
                </span>
              </div>
              ;
            </div>
            <div className="formButtons-block">
              <Button
                startIcon={<SaveIcon />}
                style={{
                  background:
                    "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
                }}
                type="submit"
                onClick={saveData}
                variant="contained"
                sx={{ mt: 2, mb: 2 }}
              >
                Save
              </Button>
              <Button
                startIcon={<RotateLeftIcon />}
                style={{
                  background:
                    "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
                }}
                onClick={resrthandle}
                variant="contained"
                sx={{ mt: 2, mb: 2 }}
              >
                Reset
              </Button>
            </div>
          </form>
        </div>
      );
    case 2:
      return (
        <Assignment
          data={Data}
          changeStep={(step) => {
            setstep(step);
          }}
        />
      );
    default:
      return <div>Error: Invalid User Role</div>;
  }
};

export default AssignArbitrator;
